module.exports = __webpack_public_path__ + "70187a7ad8028d23b75adc1735f887dc.ttf";